import React from 'react';
import { useIntl } from 'react-intl';

import { useCurrentTheme } from 'app/shared/theme';
import { getMapUrl } from 'app/shared/utils/getMapUrl';
import { Icon } from 'app/shared/components/atoms';
import { Typography } from 'app/shared/components/atoms';
import { NavigationLink as Link } from 'app/shared/components/atoms';
import { ReactComponent as ExternalLink } from 'icons/external-link.svg';

interface NeighborhoodLinkProps {
  neighborhoodTitle: string;
  cityTitle: string;
}

export const NeighborhoodLink: React.FC<
  React.PropsWithChildren<NeighborhoodLinkProps>
> = ({ neighborhoodTitle, cityTitle, ...props }) => {
  const { colors } = useCurrentTheme();
  const { formatMessage } = useIntl();

  if (neighborhoodTitle == formatMessage({ id: 'shared.secretLocation' })) {
    return (
      <Typography
        color={colors.primary.white.base}
        fontSize="fontSize300"
        fontWeight="medium"
        {...props}
      >
        {neighborhoodTitle}
      </Typography>
    );
  }

  return (
    <Link
      href={getMapUrl(`${neighborhoodTitle}, ${cityTitle}`)}
      openInNewTab={true}
      variant="primary"
      fontSize="fontSize300"
      svgFillColor="transparent"
      fontWeight="medium"
      gap={2}
      alignItems="center"
      textDecoration="none"
      {...props}
    >
      {neighborhoodTitle}
      <Icon
        strokeColor={colors.primary.black.base}
        fillColor="transparent"
        display="inline-flex"
        icon={ExternalLink}
        size="md"
      />
    </Link>
  );
};
